export enum PaymentChannel {
  SHOW_TO_PAY = 'SHOW_TO_PAY',
  PAY_WITH_LYNK = 'PAY_WITH_LYNK',
  SCAN_AND_PAY = 'SCAN_AND_PAY',
  PAYMENT_REQUEST_LINK = 'PAYMENT_LINK',
  FIND_AND_PAY = 'FIND_AND_PAY'
}
